import {IPageProps} from '../index';

export const SURVEY_CULTURAL_ECOSYSTEMS = 330;
export const SURVEY_RESEARCH_CALL = 340;

export const FIELD_MAPPING: any = {
    score: {
        [SURVEY_CULTURAL_ECOSYSTEMS]: 'domanda16',
        [SURVEY_RESEARCH_CALL]: 'domanda13',
        default: 'totale_punteggi_pesati'
    },
};

export const getValueBySurvey = (page: IPageProps | undefined, submission: any, key: string) => {
    let mapping: any = {};

    if (page && page.value.hasOwnProperty('question_mapping')) {
        page.value.question_mapping?.forEach((questionMapping) => {
            const mappingData: any = {};

            questionMapping.surveys.forEach((surveys) => {
                mappingData[surveys.survey] = surveys.slug;
            })

            mapping[questionMapping.slug] = mappingData;
        });
    } else  {
        mapping = FIELD_MAPPING;
    }

    if (mapping.hasOwnProperty(key)) {
        const params = mapping[key];
        const surveyID = Number(submission.survey_id);
        const valueKey = params.hasOwnProperty(surveyID) ? params[surveyID] : params.default;
        let value = null;

        if (submission.hasOwnProperty(valueKey)) {
            value = submission[valueKey];
        }

        return value;
    }

    return null;
}